import './templates.css'

const OTSLogoBanner = () => (
    <div className="ots-logo-banner-container">
        <img className="ots-logo-banner" src="/logo_fullsize.png" />
    </div>
)

const EmbeddedSlideDeck = ({ url }) => {
    return (
        <iframe
            src={url}
            frameborder="0"
            className="slide-deck"
            allowfullscreen="true"
            mozallowfullscreen="true"
            webkitallowfullscreen="true"></iframe>
    )
}

const ErrLoadingMsg = ({ err }) => <p style={{ textAlign: 'center', textIndent: 0 }}>there was an error loading this content. {err && (<code>err message: {JSON.stringify(err)}</code>)}</p>

const GetInvolvedMsg = () => <p className="text_container">If you want to organize for Palestine with OTS fill out this <a href="https://docs.google.com/forms/d/e/1FAIpQLSddcemMI1Vm0JnJUc93_5pA1zGBoWVJWDn9DPAafLa3JOokOQ/viewform">Get Involved Form</a> and an onboarder will reach out to go over our charter and help you get involved in a way that feels accessible for you.</p>

const PageIntro = ({ children }) => <p id="page-intro">{children}</p>

const DocContent = ({ children }) => <div className="doc-content">{children}</div>

const DocSection = ({ title, symbol, children }) => {
    return (
        <section className="doc-section">
            <header className="doc-section" >
                {title && (<h3 className="doc-section-title">{(symbol == undefined) && (<span className='doc-section-symbol'>&sect; &nbsp;</span>)}{title}</h3>)}
            </header>
            {children}
        </section>
    )
}


export { OTSLogoBanner, EmbeddedSlideDeck, PageIntro, DocSection, DocContent, GetInvolvedMsg, ErrLoadingMsg }